
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile-public/[uid]",
      function () {
        return require("private-next-pages/profile-public/[uid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile-public/[uid]"])
      });
    }
  